import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../redux/modules/actions';
import Breadcrumb             from './Breadcrumb';

const mapStateToProps = (state) => {
  return {
    currentView:  state.views.currentView
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        enterBreadcrumb: actions.enterBreadcrumb,
        leaveBreadcrumb: actions.leaveBreadcrumb
      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Breadcrumb);



// WEBPACK FOOTER //
// ./src/app/views/breadcrumb/index.js